
<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import {useCustomerStore} from "@/stores/checkinStore.js";

const router = useRouter()
const counter = ref(10)
const store = useCustomerStore()

let interval = null

const formattedTime = ref('')
onMounted(() => {
    interval = setInterval(() => {
        if (counter.value > 0) {
            counter.value--
        } else {
            clearInterval(interval)
            router.push('/kiosk')
        }
    }, 1000)

    const now = new Date()

    formattedTime.value = now.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit'
    })
})

onUnmounted(() => {
    clearInterval(interval)
})

</script>
<template>
    <div class="confirm-container">

        <!-- Header -->
        <div class="header">
            <v-row>
                <v-col cols="12">
                    <span class="title text-center">CONFIRMAÇÃO</span>
                </v-col>
            </v-row>
        </div>

        <!-- Success Icon -->
        <div class="success-wrapper">
            <div class="ring-outer">
                <div class="ring-inner">
                    <div class="icon-circle">
                        <i class="material-symbols-outlined">check</i>
                    </div>
                </div>
            </div>
        </div>

        <!-- Text -->
        <h2 class="headline">
            Em breve você será chamado pelo nome no painel
        </h2>

        <!-- Ticket Card -->
        <v-card class="ticket-card">
            <p class="ticket-label">Atendimento registrado com sucesso para </p>
            <h1 class="ticket-number">{{store?.customer?.customer_name}}</h1>

            <div class="ticket-time">
                <i class="material-symbols-outlined">schedule</i>
                <span>Registrado às {{formattedTime}}</span>
            </div>
        </v-card>

        <!-- Button -->
        <v-btn
            block
            size="large"
            rounded="pill"
            color="primary"
            class="finish-btn"
            @click="$router.push('/kiosk')"
        >
            Finalizar
            <i class="material-symbols-outlined ml-2">done_all</i>
        </v-btn>

        <!-- Footer -->
        <v-row class="countdown">
            <v-col cols="12" class=" d-flex justify-center  me-0 pe-0 ga-2">
                <div class="dots-loader d-flex justify-center ">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <span> Limpando sessão em {{ counter }}s...</span>
            </v-col>


        </v-row>

    </div>
</template>
<style scoped>

.dots-loader {
    display: flex;
    justify-content: center;
    gap: 6px;
    margin-top: 5px;
}

.dots-loader span {
    width: 9px;
    height: 9px;
    background: #94a3b8;
    border-radius: 50%;
    animation: blink 1.4s infinite both;
}

.dots-loader span:nth-child(2) { animation-delay: .2s; }
.dots-loader span:nth-child(3) { animation-delay: .4s; }

@keyframes blink {
    0% { opacity: .2; }
    20% { opacity: 1; }
    100% { opacity: .2; }
}

.confirm-container {
    max-width: 820px;
    margin: auto;
    padding: 20px;
    text-align: center;
    font-family: system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
}

/* Header */
.header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
}

.title {
    flex: 1;
    text-align: center;
    font-weight: 600;
    letter-spacing: 0.08em;
    font-size: 13px;
}

/* Success Icon */
.success-wrapper {
    margin: 28px 0 18px;
    display: flex;
    justify-content: center;
}

.ring-outer {
    width: 140px;
    height: 140px;
    border-radius: 50%;
    background: #dcfce7;
    display: flex;
    align-items: center;
    justify-content: center;
}

.ring-inner {
    width: 110px;
    height: 110px;
    border-radius: 50%;
    background: #22c55e;
    display: flex;
    align-items: center;
    justify-content: center;
}

.icon-circle {
    width: 56px;
    height: 56px;
    background: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #22c55e;
    font-size: 32px;
}

/* Text */
.headline {
    margin-top: 10px;
}

.subtitle {
    font-size: 14px;
    color: #64748b;
    margin: 12px 0 20px;
}

/* Ticket Card */
.ticket-card {
    padding: 20px;
    border-radius: 18px;
    box-shadow: 0 6px 20px rgba(0,0,0,0.06);
    margin-bottom: 26px;
}

.ticket-label {
    font-size: 12px;
    color: #94a3b8;
    letter-spacing: 0.08em;
}

.ticket-number {
    font-size: 38px;
    font-weight: 800;
    color: #1e6f86;
    margin: 6px 0 8px;
}

.ticket-time {
    font-size: 13px;
    color: #94a3b8;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
}

/* Button */
.finish-btn {
    height: 54px;
    font-weight: 600;
}

/* Footer */
.countdown {
    font-size: 13px;
    color: #94a3b8;
    margin-top: 14px;
}
</style>
